import dayjs from 'dayjs';
import { type IComputeMathFunction } from './IComputeMathFunction.ts';

export const ComputeMathDateFunctions: IComputeMathFunction[] = [
  {
    name: 'differenza_giorni',
    description:
      'Restituisce il numero di giorni di differenza tra due date. (Data1, Data2)',
    arguments: [{ type: 'string' }, { type: 'string' }],
    returnType: 'number',
    signature: 'differenza_giorni(Data1: Data, Data2: Data): Numero',
    fn: MathJs =>
      MathJs.typed('differenza_giorni', {
        'string, string'(first: string, second: string) {
          const firstDate = dayjs(first);
          const secondDate = dayjs(second);
          return secondDate.diff(firstDate, 'day');
        },
      }),
  },
  {
    name: 'differenza_mesi',
    description:
      'Restituisce il numero di mesi di differenza tra due date. (Data1, Data2)',
    arguments: [{ type: 'string' }, { type: 'string' }],
    returnType: 'number',
    signature: 'differenza_giorni(Data1: Data, Data2: Data): Numero',
    fn: MathJs =>
      MathJs.typed('differenza_mesi', {
        'string, string'(first: string, second: string) {
          const firstDate = dayjs(first);
          const secondDate = dayjs(second);
          return secondDate.diff(firstDate, 'months');
        },
      }),
  },
];
